import { createGlobalStyle, css } from 'styled-components'
import { spacing } from 'syf-component-library/defaultTheme'

/*
 * V3 styled-component overrides for InactivityTimer portal buttons.
 *
 * InactivityTimer renders via a portal (#inactivity-modal)
 */

const buttonV3BaseReset = css`
  all: unset;
  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--syfds-spacing-button-gap);
  border-radius: var(--syfds-button-border-radius-md);
  border: none;
  cursor: pointer;
  width: fit-content;
  text-decoration: none;

  font-family: var(--syfds-typography-label-large-emphasized-font-family);
  font-size: var(--syfds-typography-label-large-emphasized-font-size);
  font-weight: var(--syfds-typography-label-large-emphasized-font-weight);
  line-height: var(--syfds-typography-label-large-emphasized-line-height);
  letter-spacing: var(--syfds-typography-label-large-emphasized-letter-spacing);

  padding: var(--syfds-spacing-button-vert-padding-lg)
    var(--syfds-spacing-button-horiz-padding-lg);
  min-width: var(--syfds-spacing-button-min-width-lg);
  height: var(--syfds-size-component-xlg);

  &::after {
    background-image: none;
    transform: none;
    transition: none;
  }

  &:disabled {
    cursor: not-allowed;
  }
`

const v3FocusRing = css`
  &:focus-visible {
    outline: none;
    &::after {
      content: '';
      display: block;
      position: absolute;
      inset: -4px;
      width: auto;
      height: auto;
      background-image: none;
      background-color: transparent;
      border: var(--syfds-focus-ring-border-width-default) solid
        var(--syfds-focus-ring-color-border-default);
      border-radius: inherit;
      pointer-events: none;
      transform: none;
      opacity: 1;
      transition: none;
    }
  }
`

const v3PrimaryProps = css`
  background-color: var(--syfds-button-primary-color-background-brand-default);
  color: var(--syfds-button-primary-color-content-brand-default);

  &:hover:not(:disabled) {
    background-color: var(--syfds-button-primary-color-background-brand-hover);
    color: var(--syfds-button-primary-color-content-brand-hover);
  }
  &:active:not(:disabled) {
    background-color: var(--syfds-button-primary-color-background-brand-active);
    color: var(--syfds-button-primary-color-content-brand-active);
  }
  &:disabled {
    background-color: var(--syfds-button-primary-color-background-disabled);
    color: var(--syfds-button-primary-color-content-disabled);
  }
`

const v3TertiaryProps = css`
  background-color: var(--syfds-button-tertiary-color-background-brand-default);
  color: var(--syfds-button-tertiary-color-content-brand-default);

  &:hover:not(:disabled) {
    background-color: var(--syfds-button-tertiary-color-background-brand-hover);
    color: var(--syfds-button-tertiary-color-content-brand-hover);
  }
  &:active:not(:disabled) {
    background-color: var(
      --syfds-button-tertiary-color-background-brand-active
    );
    color: var(--syfds-button-tertiary-color-content-brand-active);
  }
  &:disabled {
    color: var(--syfds-button-tertiary-color-content-disabled);
  }
`

const sharedInactivityButtonSpacing = css`
  margin: ${spacing.small}px;
  margin-bottom: 20px;
  width: 300px;
  max-width: 100%;
`

const InactivityV3Overrides = createGlobalStyle`
  #inactivity-modal button:first-of-type {
    ${buttonV3BaseReset}
    ${v3FocusRing}
    ${v3PrimaryProps}
    ${sharedInactivityButtonSpacing}
  }

  #inactivity-modal button:last-of-type {
    ${buttonV3BaseReset}
    ${v3FocusRing}
    ${v3TertiaryProps}
    ${sharedInactivityButtonSpacing}
  }
`

export default InactivityV3Overrides
